import styled from 'styled-components'

import { Subtitle as IndexLayoutSubtitle } from 'components/IndexLayout'
import { Text } from '@sketch/components'

export const FormContainer = styled.div`
  margin: 32px 0 40px;
`
export const LinkDescription = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.C',
})`
  margin-bottom: 8px;
`

export const Subtitle = styled(IndexLayoutSubtitle)`
  max-width: 400px;
  margin: 8px auto 0;
`
